// extracted by mini-css-extract-plugin
export var dayLabel = "_lp-0";
export var pickerDisabled = "_lp-1";